import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { usePageMeta } from '../../hooks/usePageMeta';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export default function FAQPage() {
  // 設定 FAQ 頁 Meta
  usePageMeta({
    title: '常見問題 FAQ | laigame手遊代儲',
    description: 'laigame手遊代儲常見問題解答，包含訂單查詢、付款問題、儲值流程、帳號安全、防詐騙須知等完整說明，24小時客服隨時為您解答疑問。',
    keywords: '常見問題,FAQ,訂單查詢,付款問題,儲值流程,帳號安全,防詐騙,客服,laigame',
    ogTitle: '常見問題 FAQ | laigame手遊代儲',
    ogDescription: 'laigame手遊代儲常見問題解答，包含訂單查詢、付款問題、儲值流程、帳號安全等完整說明'
  });

  const [activeCategory, setActiveCategory] = useState('all');
  const [expandedId, setExpandedId] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');

  const categories = [
    { id: 'all', label: '全部問題', icon: 'ri-question-line' },
    { id: 'order', label: '訂單相關', icon: 'ri-file-list-line' },
    { id: 'payment', label: '付款問題', icon: 'ri-bank-card-line' },
    { id: 'product', label: '商品問題', icon: 'ri-shopping-bag-line' },
    { id: 'account', label: '帳號問題', icon: 'ri-user-line' },
    { id: 'security', label: '防詐騙須知', icon: 'ri-shield-check-line' },
    { id: 'other', label: '其他問題', icon: 'ri-more-line' },
  ];

  const faqData: FAQItem[] = [
    {
      id: 'faq1',
      category: 'payment',
      question: '優惠券如何使用?',
      answer: '登入網站會員，將商品加入購物車點選【結帳】，輸入優惠券代碼並點選【應用】。每款優惠券有不同使用規則，請詳閱優惠券的使用說明。'
    },
    {
      id: 'faq2',
      category: 'order',
      question: '如果我訂單下錯或不想要，如何取消? 以及下單後訂單的時效是多久?',
      answer: '未繳費完成的訂單將在下單後的隔天23:59後由系統自動取消，逾期後繳費代碼也將失效。'
    },
    {
      id: 'faq3',
      category: 'account',
      question: '收不到註冊驗證碼、繳費代碼、點卡序號簡訊怎麼辦?',
      answer: '可能是電信延遲，先稍等5-10分鐘，並到訊號良好的地方。如果以上方式都無法解決請私訊粉絲專頁，告訴客服你收不到哪種簡訊，我們會協助您解決。'
    },
    {
      id: 'faq4',
      category: 'product',
      question: '我搜尋到我要的遊戲，但找不到我要的禮包或商品?',
      answer: '看您要什麼禮包就下什麼金額的台幣禮包，並在備註或描述留下你要的禮包完整名稱，如果結帳時忘記留，可以在訂單留言板中補充。\n\n範例Q: 棒球殿堂2017的270台幣禮包，遊戲內商店有兩種270元的商品，所以不知道怎麼下?\n範例A: A禮包遊戲內金額是270，但我們賣場裡沒有這個品項，您就下270台幣禮包，再幫我們留下您要的禮包名稱【A禮包】即可。\n\n如找不到對應金額的台幣禮包請私訊粉專客服。'
    },
    {
      id: 'faq5',
      category: 'product',
      question: '我要購買遊戲內預購商品可以嗎?',
      answer: '預購禮包或新產品請私訊粉絲團客服人員，提供你需要的商品名稱與圖片，我們會替您上架。'
    },
    {
      id: 'faq6',
      category: 'product',
      question: '我搜尋不到我要的遊戲?',
      answer: '請私訊粉絲團客服人員，提供你想購買的遊戲圖片與資訊，測試大約需要7-14的工作天，測試通過會馬上通知，未通過將不另行告知，請粉絲耐心等候。'
    },
    {
      id: 'faq7',
      category: 'account',
      question: '為什麼每次下標商品，都得重打一次帳號密碼?',
      answer: '我們最重視帳密安全，所以網站不記錄任何客人的帳密。目前大部分瀏覽器都可以記錄您的遊戲帳密，您可以自行決定是否要將遊戲帳密儲存在您的瀏覽器上。\n\n每張單處理速度不同，所以無法給您詳細時間，急用、活動或限時商品請斟酌下單，謝謝您的包容與體諒(點卡交易不受影響)。'
    },
    {
      id: 'faq8',
      category: 'order',
      question: '購買手遊代儲或點卡後要多久才會好?',
      answer: '購買點卡在繳費完成後，系統自動發送儲值代碼簡訊到您的手機，請保持手機訊號良好以免接收簡訊失敗。\n\n手遊代儲不塞單時約30-60分鐘完成，如單量較多則依照現場單量狀況為主，會依照訂單先後順序處理，付款完成後請耐心等候儲值成功簡訊，收到前請勿登入遊戲以免造成儲值失敗。\n\n提醒玩家可以檢查【訂單留言板】是否有新訊息，如您提供的帳密或禮包有問題，儲值人員會用訂單留言板與您聯絡。'
    },
    {
      id: 'faq9',
      category: 'order',
      question: '為什麼很久都沒有收到完成的簡訊?',
      answer: '可能是您的訂單有問題或目前單量過多，請至訂單留言板內查看是否有儲值人員給您的新留言。代儲為人工作業，請耐心等候，如有其他問題請私訊粉絲專頁，客服服務時間為24H。'
    },
    {
      id: 'faq10',
      category: 'order',
      question: '訂單留言板在哪裡?',
      answer: '右上角人頭圖示的【會員中心】>【訂單】> 找到你要查看或留言的訂單編號 >點選【查看訂單】> 拉到最下面有個【內容】方框就是訂單留言板，可用此與儲值人員聯絡，儲值人員有問題也會在此留言給您。'
    },
    {
      id: 'faq11',
      category: 'product',
      question: '請問我自己遊戲帳號內看不到的商品品項找你們可以買嗎?首儲雙倍或其他獎勵領過買過，找你們還有嗎?',
      answer: '我們是登您的帳號上去購買，如果您的帳號內沒有該品項，我們也不能購買喔!任何遊戲獎勵我們都是依照遊戲官方，建議您不確定的話下單前先詢問。'
    },
    {
      id: 'faq12',
      category: 'other',
      question: '可以索取儲值收據嗎?',
      answer: '如您有需要，請出示遊戲官方索討收據的證明，我們會從資料庫調出交易紀錄給您，但因筆數眾多可能需要幾個工作天，請您見諒。'
    },
    {
      id: 'faq13',
      category: 'payment',
      question: '退款要多久?',
      answer: '退款約10-15個工作天不含假日，因是一個禮拜左右退一次的，這期間內的單量都會一併處理退款，所以時間上會拉比較長，還請見諒。'
    },
    {
      id: 'faq-sec1',
      category: 'security',
      question: '如何辨識官方客服？避免被假客服詐騙',
      answer: '官方客服只會透過以下管道與您聯繫：\n\n✅ 官方 LINE 帳號（@laigame，注意有 @ 符號）\n✅ 官方 Facebook 粉絲專頁（請認明藍勾勾認證）\n✅ 本網站站內訂單留言板\n\n⛔ 請特別注意以下詐騙手法：\n• 假客服會主動私訊您要求「重新驗證帳號」\n• 假客服會聲稱「訂單異常」要求您提供驗證碼\n• 假客服會要求您點擊不明連結或掃描 QR Code\n• 假客服會要求您轉帳至個人帳戶\n\n官方絕對不會透過私訊要求您提供驗證碼或密碼，如遇可疑情況請立即停止並回報。'
    },
    {
      id: 'faq-sec2',
      category: 'security',
      question: '驗證碼安全須知：什麼情況下需要提供驗證碼？',
      answer: '驗證碼（包含 Google Authenticator、簡訊驗證碼、Email 驗證碼）是保護您帳號的最後一道防線。\n\n✅ 合法情況（僅限以下）：\n• 您主動下單代儲，操作人員在儲值過程中透過「訂單留言板」請求驗證碼\n• 您自行登入本網站時的身份驗證\n\n⛔ 以下情況絕對不要提供驗證碼：\n• 任何人透過 LINE、FB、電話主動向您索取\n• 聲稱「系統異常」需要驗證碼才能完成訂單\n• 要求您截圖驗證碼傳送給對方\n• 要求您在不明網站輸入驗證碼\n\n⚠️ 重要提醒：官方操作人員只會在訂單留言板內溝通，絕對不會私下向您索取任何驗證碼。'
    },
    {
      id: 'faq-sec3',
      category: 'security',
      question: '我的帳號密碼提交後會被保存嗎？資料安全嗎？',
      answer: '您的帳號安全是我們最重視的事項，以下是我們的資料保護機制：\n\n🔒 SSL 全程加密：所有資料傳輸均採用 256-bit SSL/TLS 加密，任何第三方無法截取。\n\n🔥 閱後即焚機制：訂單完成後 24 小時內，系統自動遮蔽並從資料庫中永久刪除您的帳號密碼欄位，不留任何紀錄。\n\n👤 最小權限原則：帳密資料僅限負責該訂單的操作人員查看，其他人員無法存取。\n\n✅ 建議您在儲值完成後立即修改遊戲密碼，這是保護帳號安全的最佳實踐。'
    },
    {
      id: 'faq-sec4',
      category: 'security',
      question: '遇到疑似詐騙或可疑情況，我該怎麼辦？',
      answer: '如果您遇到任何可疑情況，請立即採取以下步驟：\n\n1️⃣ 立即停止操作，不要提供任何個人資料或驗證碼\n2️⃣ 截圖保存對話紀錄作為證據\n3️⃣ 透過官方管道回報：\n   • 官方 LINE：@laigame\n   • 官方 FB 粉專私訊\n   • 本網站客服\n4️⃣ 如已遭受損失，請向警政署 165 反詐騙專線舉報\n5️⃣ 立即修改您的遊戲帳號密碼及相關帳號密碼\n\n我們承諾：收到回報後將在 1 小時內回應，並協助您處理後續事宜。'
    },
    {
      id: 'faq-sec5',
      category: 'security',
      question: '為什麼你們的代儲是「0 鎖號保證」？來源合法嗎？',
      answer: '我們的「0 鎖號保證」建立在以下合法操作基礎上：\n\n✅ 合法來源：所有儲值均透過遊戲官方商城或合法授權管道進行，絕不使用盜刷信用卡（黑卡）或非法取得的點數。\n\n✅ 非黑卡保證：黑卡（盜刷卡）儲值會導致遊戲官方追回點數並鎖號，我們的來源 100% 合法，不存在此風險。\n\n✅ 人工操作：由真人操作人員登入您的帳號進行儲值，不使用任何外掛或自動化工具，符合遊戲官方規範。\n\n如儲值後發生任何帳號問題，請立即聯繫我們，我們將全力協助處理。'
    },
  ];

  useEffect(() => {
    const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

    // FAQPage Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "url": `${SITE_URL}/faq`,
      "mainEntity": faqData.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "首頁",
          "item": SITE_URL
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "常見問題 FAQ",
          "item": `${SITE_URL}/faq`
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.id = 'faq-page-schema';
    faqScript.text = JSON.stringify(faqSchema);
    document.head.appendChild(faqScript);

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.id = 'faq-breadcrumb-schema';
    breadcrumbScript.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScript);

    return () => {
      ['faq-page-schema', 'faq-breadcrumb-schema'].forEach(sid => {
        const el = document.getElementById(sid);
        if (el) document.head.removeChild(el);
      });
    };
  }, []);

  const filteredFAQs = faqData.filter(faq => {
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    const matchesSearch = searchQuery === '' || 
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const toggleExpand = (id: string) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 to-blue-50/30">
      <Header />
      
      <main className="flex-1 py-8">
        <div className="max-w-7xl mx-auto px-4">
          {/* Breadcrumb */}
          <div className="mb-6">
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Link to="/" className="hover:text-[#2563eb] transition-colors">首頁</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-gray-900 font-medium">常見問題</span>
            </div>
          </div>

          {/* Hero Section */}
          <div className="bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] rounded-3xl p-8 md:p-12 mb-8 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
            <div className="relative z-10">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl backdrop-blur-sm">
                  <i className="ri-question-answer-line text-3xl"></i>
                </div>
                <div>
                  <h1 className="text-3xl md:text-4xl font-bold mb-2">購物 Q&amp;A</h1>
                  <p className="text-blue-100 text-lg">常見問題解答，快速找到您需要的答案</p>
                </div>
              </div>
            </div>
          </div>

          {/* Search Bar */}
          <div className="mb-8">
            <div className="relative max-w-2xl mx-auto">
              <input
                type="search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜尋問題關鍵字..."
                className="w-full px-6 py-4 pl-14 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-[#2563eb] text-base shadow-sm"
              />
              <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              )}
            </div>
          </div>

          {/* Category Tabs */}
          <div className="mb-8">
            <div className="flex flex-wrap gap-3 justify-center">
              {categories.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all whitespace-nowrap ${
                    activeCategory === cat.id
                      ? 'bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white shadow-lg'
                      : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-200'
                  }`}
                >
                  <i className={`${cat.icon} text-lg`}></i>
                  <span>{cat.label}</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                    activeCategory === cat.id
                      ? 'bg-white/20'
                      : 'bg-gray-100'
                  }`}>
                    {cat.id === 'all' 
                      ? faqData.length 
                      : faqData.filter(f => f.category === cat.id).length}
                  </span>
                </button>
              ))}
            </div>
          </div>

          {/* FAQ List */}
          <div className="max-w-4xl mx-auto">
            {filteredFAQs.length === 0 ? (
              <div className="bg-white rounded-2xl shadow-sm p-16 text-center">
                <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center bg-gray-100 rounded-full">
                  <i className="ri-search-line text-5xl text-gray-400"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">找不到相關問題</h3>
                <p className="text-gray-600 mb-6">請嘗試其他關鍵字或聯絡客服</p>
                <button
                  onClick={() => {
                    setSearchQuery('');
                    setActiveCategory('all');
                  }}
                  className="px-6 py-3 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white rounded-xl hover:shadow-lg transition-all font-semibold whitespace-nowrap"
                >
                  重置搜尋
                </button>
              </div>
            ) : (
              <div className="space-y-4">
                {filteredFAQs.map((faq, index) => (
                  <div
                    key={faq.id}
                    className="bg-white rounded-2xl shadow-sm border-2 border-gray-100 overflow-hidden hover:shadow-md transition-all"
                  >
                    <button
                      onClick={() => toggleExpand(faq.id)}
                      className="w-full px-6 py-5 flex items-start gap-4 text-left hover:bg-gray-50 transition-colors"
                    >
                      <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-gradient-to-br from-[#1a1f5e] to-[#2563eb] text-white rounded-xl font-bold">
                        {index + 1}
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-lg font-bold text-gray-900 mb-1 pr-8">
                          {faq.question}
                        </h3>
                        <div className="flex items-center gap-2">
                          <span className="px-3 py-1 bg-blue-50 text-[#2563eb] text-xs rounded-full font-semibold">
                            {categories.find(c => c.id === faq.category)?.label}
                          </span>
                        </div>
                      </div>
                      <div className="flex-shrink-0">
                        <i className={`ri-arrow-${expandedId === faq.id ? 'up' : 'down'}-s-line text-2xl text-gray-400 transition-transform`}></i>
                      </div>
                    </button>
                    
                    {expandedId === faq.id && (
                      <div className="px-6 pb-6 pt-2 border-t-2 border-gray-100 animate-fadeIn">
                        <div className="pl-14">
                          <div className="flex items-start gap-3 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-5">
                            <i className="ri-chat-check-line text-2xl text-[#2563eb] flex-shrink-0 mt-1"></i>
                            <div className="flex-1">
                              <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                                {faq.answer}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Contact Section */}
          <div className="mt-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/10 rounded-full -ml-24 -mb-24"></div>
            <div className="relative z-10 text-center max-w-2xl mx-auto">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-white/20 rounded-2xl backdrop-blur-sm">
                <i className="ri-customer-service-2-line text-4xl"></i>
              </div>
              <h2 className="text-3xl font-bold mb-4">還有其他問題？</h2>
              <p className="text-lg text-white/90 mb-8">
                我們的客服團隊 24 小時在線，隨時為您解答疑問
              </p>
              <div className="flex flex-wrap gap-4 justify-center">
                <a
                  href="https://line.me/R/ti/p/@laigame"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 px-8 py-4 bg-white text-purple-600 rounded-xl hover:bg-yellow-300 hover:text-purple-700 transition-all font-bold whitespace-nowrap shadow-lg"
                >
                  <i className="ri-line-fill text-xl"></i>
                  LINE 客服
                </a>
                <a
                  href="https://www.facebook.com/laigame"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 px-8 py-4 bg-white text-purple-600 rounded-xl hover:bg-yellow-300 hover:text-purple-700 transition-all font-bold whitespace-nowrap shadow-lg"
                >
                  <i className="ri-facebook-fill text-xl"></i>
                  Facebook 粉專
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}